import { useNutritionFlags } from "../../hooks/useNutritionFlags";
import { MenuAnalyticsDashboard } from "./Dashboard";
import { MenuAnalyticsUnavailable } from "./states";

/**
 * Route entry point for the Menu Order Analytics dashboard (NUT-2024).
 *
 * Gated on the `menuAnalyticsDashboardEnabled` LaunchDarkly flag. The Kitchen nav
 * tab is only shown when the flag is on, but the route is always registered, so
 * direct navigation while the flag is off renders a graceful unavailable state
 * rather than a blank screen.
 */
export const MenuAnalytics = () => {
  const { menuAnalyticsDashboardEnabled } = useNutritionFlags();

  if (!menuAnalyticsDashboardEnabled) {
    return <MenuAnalyticsUnavailable />;
  }

  return <MenuAnalyticsDashboard />;
};
